import React, { useContext, Children } from 'react';

import { TabsContext } from './TabsContext';
import styles from './tabs.module.css';

export type TabsProps = React.PropsWithChildren

export const Tabs = ({children}: TabsProps)=> {
  const {handleKeyDown} = useTabs(Children.count(children))

  return (
    <div className={styles.wrapper} role='tablist' onKeyDown={handleKeyDown}>
      {children}
    </div>
  )
};

export const useTabs = (nbChild: number) => {
  const {currentIndex, setCurrentIndex} = useContext(TabsContext)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
    if (e.altKey || e.shiftKey || e.ctrlKey || e.metaKey) {
      return;
    }

    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1)
        break;
      case 'ArrowRight':
        e.preventDefault();
        if (currentIndex < nbChild - 1) setCurrentIndex(currentIndex + 1)
        break;
      case 'Home':
        e.preventDefault();
        setCurrentIndex(0)
        break;
      case 'End':
        e.preventDefault();
        setCurrentIndex(nbChild - 1)
        break;
      default:
        break;
    }
  }

  return {handleKeyDown}
}
